import { motion } from "motion/react";
import { Filter } from "lucide-react";

import CapsCategoryFilters from "@/theme2/components/caps/CapsCategoryFilters";
import CapsSortDropdown from "@/theme2/components/caps/CapsSortDropdown";
import CapsViewToggle from "@/theme2/components/caps/CapsViewToggle";

export default function CapsToolbar({
  productCount,
  filters,
  activeFilter,
  onFilterChange,
  sortOptions,
  sort,
  onSortChange,
  view,
  onViewChange,
}) {
  return (
    <motion.section
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className="sticky top-[7.5rem] z-30 rounded-[1.75rem] border border-border/70 bg-white/90 p-4 shadow-xl shadow-black/5 backdrop-blur-xl"
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div>
            <p className="text-xs font-black uppercase tracking-[0.24em] text-muted-foreground">
              Complete Caps Collection
            </p>
            <p className="mt-1 text-sm font-semibold">
              {productCount} {productCount === 1 ? "product" : "products"}
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <button
              type="button"
              className="inline-flex min-h-11 items-center gap-2 rounded-full border border-border px-4 py-2 text-sm font-semibold transition hover:border-neutral-950 focus:outline-none focus:ring-2 focus:ring-neutral-950"
              aria-label="Open advanced filters"
            >
              <Filter className="size-4" />
              Filters
            </button>

            <CapsSortDropdown
              options={sortOptions}
              value={sort}
              onChange={onSortChange}
            />

            <CapsViewToggle value={view} onChange={onViewChange} />
          </div>
        </div>

        <CapsCategoryFilters
          filters={filters}
          value={activeFilter}
          onChange={onFilterChange}
        />
      </div>
    </motion.section>
  );
}